export default __webpack_public_path__ + "static/media/Group 560.a1b37a23.png";